// 产品管理
import request from '@/utils/request'
// 供应
	// 供应产品分类
	export function supply_cate(data) {
	  return request({
	    url: '/index/person/supply_cate',
	    method: 'post',
	    data: data,
	  })
	}

	// 供应产品材质
	export function supply_material(data) {
	  return request({
	    url: '/index/person/supply_material',
	    method: 'post',
	    data: data,
	  })
	}

	// 供应产品适用范围/工艺
	export function supply_range(data) {
	  return request({
	    url: '/index/person/supply_range',
	    method: 'post',
	    data: data,
	  })
	}

	// 供应产品风格
	export function supply_style() {
	  return request({
	    url: '/index/person/supply_style',
	    method: 'post',
	  })
	}

	// 供应产品列表
	export function supply_list(data) {
	  return request({
	    url: '/index/person/supply_list',
	    method: 'post',
	    data: data,
	  })
	}

	// 删除供应产品
	export function supply_del(data) {
	  return request({
	    url: '/index/person/supply_del',
	    method: 'post',
	    data: data,
	  })
	}

	// 供应产品发布数量查询
	export function supply_search(data) {
	  return request({
	    url: '/index/person/supply_search',
	    method: 'post',
	    data: data,
	  })
	}

	// 获取一物一码数据列表
	export function qrcode_list(data) {
	  return request({
	    url: '/index/person/qrcode_list',
	    method: 'post',
	    data: data,
	  })
	}

	// 检查产品编码是否重复
	export function number_suffix_recheck(data) {
	  return request({
	    url: '/index/person/number_suffix_recheck',
	    method: 'post',
	    data: data,
	  })
	}

	// 生成二维码
	export function mini_qrcode(data) {
	  return request({
	    url: '/index/weixin/mini_qrcode',
	    method: 'post',
	    data: data,
	  })
	}

	// 下载二维码
	export function qrcode_download(data) {
	  return request({
	    url: '/index/person/qrcode_download',
	    method: 'post',
	    data: data,
	  })
	}

	// 购买二维码
	export function buy_qrcode(data) {
	  return request({
	    url: '/index/person/buy_qrcode',
	    method: 'post',
	    data: data,
	  })
	}

	// 查询是否有购买二维码订单
	export function qrcode_order_search(data) {
	  return request({
	    url: '/index/person/qrcode_order_search',
	    method: 'post',
	    data: data,
	  })
	}

	// 生成二维码订单
	export function update_qrcode_number(data) {
	  return request({
	    url: '/index/person/update_qrcode_number',
	    method: 'post',
	    data: data,
	  })
	}

// 发布供应

	// 提交表单-新建供应信息
	export function supply_edit(data) {
	  return request({
	    url: '/index/person/supply_edit',
	    method: 'post',
	    data: data,
	  })
	}

	// 提交表单-编辑供应信息
	export function supply_info(data) {
	  return request({
	    url: '/index/person/supply_info',
	    method: 'post',
	    data: data,
	  })
	}

	// 提交表单前提取图片
	export function extract_feature(data) {
	  return request({
	    url: '/index/algorithm/extract_feature',
	    method: 'post',
	    data: data,
	  })
	}

	// 自定义分类的增加和编辑
	export function diy_cate_add(data) {
	  return request({
	    url: '/index/person/diy_cate_add',
	    method: 'post',
	    data: data,
	  })
	}

	// 获取自定义分类列表
	export function diy_cate_list(data) {
	  return request({
	    url: '/index/person/diy_cate_list',
	    method: 'post',
	    data: data,
	  })
	}

	// 新增或者编辑产品编号前缀
	export function number_prefix_add(data) {
	  return request({
	    url: '/index/person/number_prefix_add',
	    method: 'post',
	    data: data,
	  })
	}

	// 获取产品编号后缀
	export function get_number_suffix(data) {
	  return request({
	    url: '/index/person/get_number_suffix',
	    method: 'post',
	    data: data,
	  })
	}

	// 获取产品编号前缀列表
	export function number_prefix_list(data) {
	  return request({
	    url: '/index/person/number_prefix_list',
	    method: 'post',
	    data: data,
	  })
	}

	// 获取业务员联系方式列表
	export function get_contact_info(data) {
	  return request({
	    url: '/index/person/get_contact_info',
	    method: 'post',
	    data: data,
	  })
	}

	// 移动bin文件---编辑用
	export function bin_move(data) {
	  return request({
	    url: '/index/algorithm/bin_move',
	    method: 'post',
	    data: data,
	  })
	}


// 采购
	// 采购产品分类
	export function buy_cate(data) {
	  return request({
	    url: '/index/person/buy_cate',
	    method: 'post',
	    data: data,
	  })
	}

	// 采购产品列表
	export function buy_list(data) {
	  return request({
	    url: '/index/person/buy_list',
	    method: 'post',
	    data: data,
	  })
	}

	// 删除采购产品
	export function buy_del(data) {
	  return request({
	    url: '/index/person/buy_del',
	    method: 'post',
	    data: data,
	  })
	}

	// 采购产品发布数量查询
	export function buy_search(data) {
	  return request({
	    url: '/index/person/buy_search',
	    method: 'post',
	    data: data,
	  })
	}

// 发布采购
	// 上传图片
	export function picUpload(data) {
	  return request({
	    url: '/index/person/picUpload',
	    method: 'post',
	    data: data,
	  })
	}

	// 提交表单
	export function buy_edit(data) {
	  return request({
	    url: '/index/person/buy_edit',
	    method: 'post',
	    data: data,
	  })
	}

	// 采购产品风格
	export function buy_style() {
	  return request({
	    url: '/index/person/buy_style',
	    method: 'post',
	  })
	}

	// 采购信息修改
	export function buy_info(data) {
	  return request({
	    url: '/index/person/buy_info',
	    method: 'post',
	    data: data,	    
	  })
	}


// 母板、模板部分----所有test改为module
	// 新增或者修改模板
	export function add_temp(data) {
	  return request({
	    // url: '/index/test/add_temp',
	    url: '/index/module/add_temp',
	    method: 'post',
	    data: data,
	  })
	}
	// 模板列表
	export function temp_list(data) {
	  return request({
	    url: '/index/module/temp_list',
	    method: 'post',
	    data: data,
	  })
	}
	// 类型列表（一级分类）
	export function get_pid(data) {
	  return request({
	    url: '/index/module/get_pid',
	    method: 'post',
	    data: data,
	  })
	}
	// 删除模板
	export function temp_del(data) {
	  return request({
	    url: '/index/module/temp_del',
	    method: 'post',
	    data: data,
	  })
	}


// WEBPACK FOOTER //
// ./src/api/userCenter/productManage.js